import React from "react"
import {connect} from "react-redux"
import {login, logout} from "../../actions/piano"
import {useWindowDimensions} from "../../customHooks/useWindowDimensions"
import { useTranslation } from "react-i18next";

function LoginLogoutForm(props) {
    const {width} = useWindowDimensions()
    const { t } = useTranslation();
    //TODO width > 930部分の解明
    if (props.isSp){
        return (
            <>
            <ul className="login-logout tp-cloak" style={width > 930 ? {display: "none"} : {}}>
            {props.isLoggedIn ? (
                <li className="show-if-logged-in pc-only">
                    <a href="#" onClick={() => props.logout()} className="login-button tp-logout">{t("header.logout")}</a>
                </li>
            ) : (
                <li className="show-if-logged-out">
                    <a href="#" onClick={() => props.login()} className="login-button tp-login">{t("header.login")}</a>
                </li>
            )}
            </ul>
            </>
        )
    }
    return (
        <>
        <ul className="login-logout tp-cloak" style={width < 930 ? {display: "none"} : {}}>
        {props.isLoggedIn ? (
            <li className="show-if-logged-in pc-only">
                <a href="#" onClick={() => props.logout()} className="login-button tp-logout">{t("header.logout")}</a>
            </li>
        ) : (
            <li className="show-if-logged-out">
                <a href="#" onClick={() => props.login()} className="login-button tp-login">{t("header.login")}</a>
            </li>
        )}
        </ul>
        </>
    )
}

const mapDispatchToProps = (dispatch) => ({
    login: () => dispatch(login()),
    logout: () => dispatch(logout()),
})

export default connect(null, mapDispatchToProps)(LoginLogoutForm)
